import { useCallback, useState } from 'react';
import cls from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import styles from './index.module.scss';

export default (props: Record<string, any>) => {
  const { navs = [], slideshow = [] } = props;
  console.log('navs====', navs, slideshow);
  const [currentNav, setCurrentNav] = useState<Record<string, any>>({});
  const gotoDetail = useCallback((item: any) => {
    if (item.redirectUrl) {
      window.open(item.redirectUrl);
    }
  }, []);
  const gotoSciexDetail = useCallback((item: any) => {
    if (item.redirectUrl) {
      window.open(item.redirectUrl);
    }
  }, []);
  return (
    <div className={cls(styles['nav-content'], 'flex')}>
      <div className={cls(styles['left-img'], 'flex1')}>
        {slideshow?.length && (
          <Swiper
            className="container"
            modules={[Autoplay]}
            autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
            spaceBetween={0}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
          >
            {(slideshow || []).map((item: any) => {
              return (
                <SwiperSlide className="card" key={4}>
                  <img src={item.url} className={styles['swipper-img']} onClick={() => gotoDetail(item)} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
        {/* <img src={slideshow[0]?.url || navBg} className={styles['nav-bg']} /> */}
      </div>
      <ul className={styles['nav-list']}>
        {navs.map((item: any) => {
          return (
            <li
              className={
                currentNav.id === item.id ? cls(styles['inner-item'], styles['selected']) : styles['inner-item']
              }
              key={item.id}
              onClick={() => gotoSciexDetail(item)}
            >
              {item.title}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
